import { PipeTransform } from '@angular/core';
var ReferralFacilitatorStatusPipe = /** @class */ (function () {
    function ReferralFacilitatorStatusPipe() {
    }
    ReferralFacilitatorStatusPipe.prototype.transform = function (referralCode) {
        if (referralCode == null) {
            return '';
        }
        switch (referralCode) {
            case 'M': // Finished by supervisor with answer
                return 'Finished by supervisor';
            case 'I': // Finished by supervisor with no info
                return 'No information available';
            case 'N': // Supervisor needs time approval
                return 'Needs Time Approval';
            default:
                return '';
        }
    };
    return ReferralFacilitatorStatusPipe;
}());
export { ReferralFacilitatorStatusPipe };
